import type { FunctionComponent } from 'react'

import { BudgetCategoryOverview } from './BudgetCategoryOverview'
import { capitalizeFirstLetter } from './budgetEstimatesUtils'
import { CategoryPointInput } from './CategoryPointInput'

export const EstimateSection: FunctionComponent<{
	// skipcq: JS-0323
	record: any
	branch?: string
	current?: string
	currentDot?: string
	currentKey?: string
	children?: never
}> = ({ record, current, currentDot, branch, currentKey }) => {
	if (currentKey === 'total') {
		return null
	}

	if (typeof record === 'object') {
		const newLocal = Object.keys(record)

		return (
			<>
				{newLocal.map((key) => {
					const oldCurrent = current != null ? current : branch
					const camelCaseCurrentKey =
						oldCurrent != null
							? `${oldCurrent}${capitalizeFirstLetter(key)}`
							: key
					const dotNotation =
						oldCurrent != null ? `${currentDot ?? oldCurrent}.${key}` : key
					let item = record[key]
					const itemKeys = Object.keys(item)
					const isEndLeaf =
						typeof item === 'number' ||
						(itemKeys.length === 1 && itemKeys[0] === 'total')

					if (itemKeys.length === 1 && itemKeys[0] === 'total') {
						item = item.total
					}

					if (isEndLeaf) {
						return (
							<EstimateSection
								key={camelCaseCurrentKey}
								record={item}
								current={camelCaseCurrentKey}
								currentDot={dotNotation}
								currentKey={key}
								// skipcq: JS-0323
								branch={branch as any}
							/>
						)
					}

					return (
						<BudgetCategoryOverview
							key={camelCaseCurrentKey}
							itemKey={camelCaseCurrentKey}
							dotKey={dotNotation}
							currentKey={key}
							total={record[key]?.total}
						>
							<EstimateSection
								record={item}
								current={camelCaseCurrentKey}
								currentDot={dotNotation}
								currentKey={key}
								// skipcq: JS-0323
								branch={branch as any}
							/>
						</BudgetCategoryOverview>
					)
				})}
			</>
		)
	}
	return (
		<CategoryPointInput
			// skipcq: JS-0323
			itemKey={current as any}
			// skipcq: JS-0323
			dotKey={currentDot as any}
			value={record}
			// skipcq: JS-0323
			branch={branch as any}
		/>
	)
}
